import { render, staticRenderFns } from "./finish.mpx?vue&type=template&id=514fa37e&scoped=true&component=true&componentId=finish5561e09b"
import script from "./finish.mpx?vue&type=script&lang=js&component=true&componentId=finish5561e09b"
export * from "./finish.mpx?vue&type=script&lang=js&component=true&componentId=finish5561e09b"
import style0 from "./finish.mpx?vue&type=style&index=0&id=514fa37e&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m5561e09b%22%7D&component=true&componentId=finish5561e09b"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514fa37e",
  null
  
)

export default component.exports